import {
  Column,
  FlexAligner,
  Spinner,
  Surface,
  Tooltip,
  TrafficLight,
  Typography,
} from '@scaleaq/scaleui';
import { StatusLevel } from '@scaleaq/sitecontrol-lib';
import { spacing } from '@scaleaq/sui-tokens/responsive';

import { StyledRow } from './stat.styles.ts';
import { StatProps, StatusData } from './state.types.ts';

export const Stat = ({ values, showStatus, translations, onLineClick }: StatProps) => {
  const ts = translations || { units: {}, labels: {} };
  return (
    <Surface color='cards' style={{ borderRadius: spacing['xlarge'], width: '100%' }}>
      <Column gap='0.625rem'>
        {values?.length > 0 &&
          values?.map(
            ({
              id,
              isConnected,
              name,
              icon,
              isLoading,
              value,
              status,
              warningOrErrorIcon,
            }: StatusData) => (
              <StyledRow
                $withPointerCursor={onLineClick !== undefined}
                onClick={onLineClick ? () => onLineClick(id) : undefined}
                gap={spacing['xlarge']}
                key={id}
              >
                <Typography type='body_medium' disabled={isConnected === false}>
                  {ts.labels[name] ?? name}
                </Typography>
                <FlexAligner
                  alignment='center-right'
                  scaling={1}
                  fullWidth={false}
                  gap={spacing['xlarge']}
                >
                  {warningOrErrorIcon}
                  {icon}
                  <FlexAligner
                    alignment='center'
                    fullWidth={false}
                    style={{ minWidth: spacing['5xlarge'] }}
                  >
                    {isLoading ? (
                      <Spinner />
                    ) : (
                      <Typography
                        type='body_medium'
                        disabled={isConnected === false}
                        style={{ minWidth: '1.75rem' }}
                      >
                        {value == null || value === '' ? '--' : String(value)}
                      </Typography>
                    )}
                  </FlexAligner>
                  {!showStatus && (
                    <Typography type='body_medium' style={{ minWidth: '1.25rem' }}>
                      {ts.units[name] ?? ''}
                    </Typography>
                  )}
                  {showStatus && (
                    <Tooltip
                      tooltip={
                        status?.level !== StatusLevel.Healthy
                          ? `${status?.level}: ${status?.message}`
                          : undefined
                      }
                    >
                      <TrafficLight
                        style={{
                          cursor: `${status?.level !== StatusLevel.Healthy ? 'pointer' : 'default'}`,
                        }}
                        type={isConnected ? 'success' : 'alarm'}
                      />
                    </Tooltip>
                  )}
                </FlexAligner>
              </StyledRow>
            )
          )}
      </Column>
    </Surface>
  );
};
